module.exports = __webpack_public_path__ + "static/media/special-olympics-ireland.04fa5671.png";